"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var styled_components_1 = require("styled-components");

var Icon_1 = require("../Icon/Icon");

var iconDefaultColor = '#00BF6C';

var IconSelected = function IconSelected(_a) {
  var theme = _a.theme;
  var color = theme.colors.system.success || iconDefaultColor;
  return react_1.default.createElement(Icon_1.Icon, {
    name: "check-circle",
    size: Icon_1.IconSizeEnum.small,
    color: color
  });
};

exports.default = styled_components_1.withTheme(IconSelected);